















































































import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'SettingBase'
})
export default class extends Vue {
  info = {
    email: 'appleguardu@163.com',
    nickName: '嘻嘻哈哈',
    country: '中国',
    province: '湖北省',
    city: '武汉市',
    phone: '13392212381',
    avatar: 'https://passport.tutuapp.com/ucenter/avatar.php?uid=3716847'
  }
  countryOptions = [{
    value: '选项1',
    label: '黄金糕'
  }, {
    value: '选项2',
    label: '双皮奶'
  }, {
    value: '选项3',
    label: '蚵仔煎'
  }, {
    value: '选项4',
    label: '龙须面'
  }, {
    value: '选项5',
    label: '北京烤鸭'
  }]
}
